import React from 'react'
import PropTypes from 'prop-types'
import { DisclaimerWrapper, DisclaimerLabel } from './styles'

export const Disclaimer = (props) => {
  return (
    <DisclaimerWrapper>
      {props.icon}
      <DisclaimerLabel weight={props.weight} left={props.left}>
        {props.text}
      </DisclaimerLabel>
    </DisclaimerWrapper>
  )
}

Disclaimer.propTypes = {
  icon: PropTypes.node,
  weight: PropTypes.string,
  left: PropTypes.string,
  text: PropTypes.string
}
